import React from 'react';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import ClickHandler from '@nykaa/deals-utils/clicks';
import { webActionTypes } from '@nykaa/deals-utils/clicks/constants';
import { Button } from './css';
import IoElement from '../IOElement';
const ButtonWidget = (props) => {
    const { title, style, clickData, isDesktop, } = props;
    const { buttonAppLinkType: appLinkType, buttonAppLinkData: appLinkData, buttonTrackingData: trackingData, buttonTrackingUrl: webActionUrl, } = clickData;
    const trackingDetails = Object.assign(Object.assign({}, trackingData), { button_type: 'button' });
    const handleClick = (e) => {
        e.preventDefault();
        ImpressionsHandler.handleClick(trackingDetails).finally(() => {
            ClickHandler.handleClick({
                appLinkData,
                appLinkType,
                webActionType: webActionTypes.URL_REDIRECTION,
                webActionUrl,
                isDesktop,
            });
        });
    };
    const handleInterset = () => {
        ImpressionsHandler.handleImpression(Object.assign({}, trackingDetails));
    };
    const { buttonText, bkg, margin, padding, visible, } = style;
    return (React.createElement(IoElement, { onIntersect: handleInterset, onIntersectV2: () => '', isServer: false },
        React.createElement(Button, { visible: visible, bkg: bkg, padding: padding, margin: margin, buttonText: buttonText, onClick: handleClick }, title)));
};
export default ButtonWidget;
